<template>
    <div>
        <vs-tabs class="bg_filled_tab_holder">
            <vs-tab label="School Opening Hours" icon="event">
                <div>
                    <OpeningHours />
                </div>
            </vs-tab> 
            <vs-tab label="School Holidays" icon="perm_media">
                <div>
                    <Holidays />
                </div>
            </vs-tab> 
            <vs-tab label="School Info" icon="content_copy">
                <div>
                    <Info />
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import OpeningHours from './opening_hours.vue'
import Holidays from './holidays.vue'
import Info from './info.vue'

export default {
  components: {
    OpeningHours,
    Holidays,
    Info
  }
}
</script>